import { Box } from '@mui/material';
import { Option } from 'components/ui/FormControls';
import React from 'react';

import {
    ArticleChangeHookType,
    ArticleEditError,
} from '../../../shared/global-enums';
import { CategoryItemNode } from '../../../shared/types';
import { categoriesToList } from '../../../utils/list-utils';
import { ArticleValidationError } from '../../../utils/validator.utils';
import { topicsOrCategories } from '../../../utils/utils';

import { Select } from 'components/ui/FormControls';

export interface ArticleTaxonomiesProps {
    selectedCategories: string[];
    selectedTags: string[];

    treeCategories: CategoryItemNode[];
    listTags: Option[];

    errorList: ArticleValidationError[];

    onChangeValue: (changeType: ArticleChangeHookType, value: string) => void;
    onChangeMultiValue: (
        changeType: ArticleChangeHookType,
        value: Option[]
    ) => void;
}

const getSelectedValues = (
    fullList: Option[],
    selectedIdList: string[]
): Option[] =>
    selectedIdList?.length > 0
        ? fullList.filter((x) => selectedIdList.includes(x.value.toString()))
        : [];

export const ArticleTaxonomies = (props: ArticleTaxonomiesProps) => {
    const tagsValue = getSelectedValues(props.listTags, props.selectedTags);

    const categoriesList = categoriesToList<Option>(
        props.treeCategories,
        (cat) => {
            return {
                label: cat.name,
                value: cat._id,
                disabled: props.selectedCategories.includes(cat._id),
                indentation: cat.level,
            };
        }
    );

    const categoriesValue = getSelectedValues(
        categoriesList,
        props.selectedCategories
    );

    const categoriesError = props.errorList.find(
        (x) => x.errorType === ArticleEditError.CategoriesAbsent
    )?.message;

    return (
        <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
            <Box sx={{ width: '100%', pb: 2 }}>
                <Select
                    id="article-select-categories"
                    size="medium"
                    clearable={true}
                    menuPlacement="auto"
                    label={topicsOrCategories(true, true)}
                    placeholder="Select from the list..."
                    value={categoriesValue}
                    multi={true}
                    hideSelectedOptions={false}
                    error={!!categoriesError}
                    errorText={categoriesError}
                    //onBlur={parentCategoryFormControl?.handleBlur}
                    onChange={(opts: Option[]) => {
                        props.onChangeMultiValue(
                            ArticleChangeHookType.TaxonomyCategories,
                            opts
                        );
                    }}
                    options={categoriesList}
                />
            </Box>
            <Box sx={{ width: '100%', pb: 2 }}>
                <Select
                    id="article-select-tags"
                    size="medium"
                    clearable={true}
                    menuPlacement="auto"
                    label="Tags"
                    placeholder="Select from the list..."
                    value={tagsValue}
                    //onBlur={parentCategoryFormControl?.handleBlur}
                    multi={true}
                    onChange={(opts: Option[]) => {
                        // changing parent
                        props.onChangeMultiValue(
                            ArticleChangeHookType.TaxonomyTags,
                            opts
                        );
                    }}
                    options={props.listTags}
                />
            </Box>
        </Box>
    );
};

export default ArticleTaxonomies;
